
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Clermont-Ferrand dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Clermont-Ferrand certifiée Google Partner, accompagne les entreprises clermontoises pour accroître leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Clermont-Ferrand dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Clermont-Ferrand certifiée Google Partner, accompagne les entreprises clermontoises pour accroître leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
